import { useRedux } from 'hooks/index';
import { seoAdminUpsert, seoAdminViewAll, seoAdminViewDetails, seoUserViewDetails } from '../../redux/cms/seoData/actions';
import { SeoDataFilter, SeoDataNew, SeoEntityType } from '../../types/cms/seoData';

export default function useSeo() {
    const { dispatch, appSelector } = useRedux();

    const { loading, apiUpsertSuccess, adminAllSeo, adminSeoDetails, userAllSeo, userSeoDetails, error } = appSelector((state) => ({
        loading: state.SeoData.loading,
        apiUpsertSuccess: state.SeoData.apiUpsertSuccess,
        adminAllSeo: state.SeoData.adminAllSeo,
        adminSeoDetails: state.SeoData.adminSeoDetails,
        userAllSeo: state.SeoData.userAllSeo,
        userSeoDetails: state.SeoData.userSeoDetails,
        error: state.SeoData.error,
    }));

    const adminLoadAllSeo = (filters: SeoDataFilter) => {
        dispatch(seoAdminViewAll(filters));
    };

    const adminLoadSeoDetails = (id: string) => {
        dispatch(seoAdminViewDetails(id));
    };

    const adminUpsertSeo = (data: SeoDataNew) => {
        dispatch(seoAdminUpsert(data));
    };

    const userLoadSeoDetails = (type: SeoEntityType, slug: string) => {
        dispatch(seoUserViewDetails(type, slug));
    };

    return {
        adminAllSeo,
        adminSeoDetails,
        userAllSeo,
        userSeoDetails,
        adminLoadAllSeo,
        adminLoadSeoDetails,
        adminUpsertSeo,
        userLoadSeoDetails,
        apiUpsertSuccess,
        error,
        loading,
    };
}
